<template>
  <section class="strongs">
    <h2>Razones para elegirnos</h2>
    <aside class="list-strongs">
      <div class="content-strong">
        <div>
          <h4>Atención las 24 horas</h4>
          <img src="@/assets/icons/garden_cart.svg" alt="" />
        </div>
        <p>Atención 24/7, incluso en feriados.</p>
      </div>
      <div class="content-strong">
        <div>
          <h4>Entregas y envíos a todo el país</h4>
          <img src="@/assets/icons/local_shipping.svg" alt="" />
        </div>
        <p>Entregas en algunos puntos de Lima y envíos a todo el Perú.</p>
      </div>
      <div class="content-strong">
        <div>
          <h4>Gran variedad de repuestos</h4>
          <img src="@/assets/icons/Group.svg" alt="" />
        </div>
        <p>Repuestos industriales y automotrices en muchas marcas</p>
      </div>
    </aside>
  </section>
</template>

<style lang="scss" scoped>
.strongs {
  display: flex;
  flex-direction: column;
  gap: 45px;
  padding-inline: 300px !important;
  margin-top: 100px !important;

  h2 {
    color: $shade1;
    font-size: 36px;
    font-weight: 600;
    line-height: normal;
    text-align: start;
    margin: 0;
  }

  .list-strongs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    .content-strong {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      gap: 10px;
      border-radius: 10px;
      background: var(--spl-1, #3a91db);
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.03);
      color: $whited;
      text-align: start;
      padding: 30px 40px;
      div {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 24px;
        font-weight: 600;
        line-height: normal;
        gap: 40px;
      }
    }
  }
}

@media (max-width: 1600px) {
  .strongs {
    padding-inline: 100px !important;
    .list-strongs {
      .content-strong {
        padding: 30px 30px;
        h4 {
          font-size: 22px;
        }
        img {
          width: 50px;
        }
      }
    }
    h2 {
      font-size: 32px;
    }
  }
}
@media (max-width: 1080px) {
  .strongs {
    padding-inline: 80px !important;
    .list-strongs {
      .content-strong {
        width: 100%;
        div {
          width: inherit;
          justify-content: space-between;
        }
      }
    }
    h2 {
      font-size: 24px;
    }
  }
}
@media (max-width: 580px) {
  .strongs {
    padding-inline: 20px !important;
    .list-strongs {
      .content-strong {
        h4 {
          font-size: 18px;
          font-weight: 600;
        }
        img {
          width: 30px;
        }
      }
    }
  }
}
</style>
